import React from 'react';
import Storage from "../../services/Storage";
import {injectIntl} from "react-intl";
import withAuthorization from "../../services/Authorization";
import connect from "react-redux/es/connect/connect";
import SAInputLabel from "../common/input/SAInputLabel";
import {Tabs} from "antd";


import Constants from "../../services/Constants";
import RichTextEditor from "../common/editor/RichTextEditor";
import './DealershipInformation.css'
import {SpinnerModal} from "../../public/components/SpinnerModal";

const {TabPane} = Tabs;

class DealershipInformation extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      bodyshopDetails: {},
      genericDescription: Constants.SUPPORTED_LANGUAGES.reduce((acc, lg) => {
        acc[lg] = '';
        return acc;
      }, {})
    };
  }

  componentDidMount() {
    this.props.dispatchFetchDealerInfo();
  }

  onSave = () => {
    const {bodyshopDetails, genericDescription} = this.state;
    const keys = {};
    this.props.dispatchSaveDealerInfo({bodyshopDetails, genericDescription});
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.dealerInfo) {
      const {genericDescription, bodyshopDetails} = nextProps.dealerInfo;
      if (genericDescription) {
        this.setState({genericDescription});
      }
      if (bodyshopDetails) {
        this.setState({bodyshopDetails});
      }
    }
  };

  onInputChange = (item, value) => {
    const {bodyshopDetails} = this.state;
    value = value.replace(/\s\s+/g, ' ');
    if (/^[+]?[(]?[0-9 ]*[)]?[0-9 ]*$/.test(value)) {
      bodyshopDetails[item] = value;
    }

    this.setState({bodyshopDetails});
  };

  onAddressChange = (item, value) => {
    const {bodyshopDetails} = this.state;
    bodyshopDetails.address = bodyshopDetails.address || {};
    bodyshopDetails.address[item] = value;
    this.setState({bodyshopDetails});
  };

  render() {
    const {intl: {formatMessage}, loading, configurationHints} = this.props;
    const {bodyshopDetails, genericDescription} = this.state;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';

    const requiredConfig = configurationHints.includes('SALES_CONDITIONS');


    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id: 'section.dealership-information.title'})}
          </h2>
          {canWrite &&
            <div className="box-heading__button">
              <button disabled={loading} onClick={() => this.onSave()} type="primary" className="btn btn-sm btn-primary">
                {formatMessage({id: 'action.save'})}
              </button>
            </div>
          }
        </header>
        {
          <div className="box__body">
            {requiredConfig && <div className={"alert alert--error"}>{formatMessage({id: 'section.requires-configuration'}, {sectionName: formatMessage({id: 'section.sales-conditions.title'})})}</div>}

            <SpinnerModal visible={loading}/>
            <div className="row">
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id: 'section.bodyshop-address.title'})}</h3>

                <SAInputLabel value={bodyshopDetails && bodyshopDetails.address && bodyshopDetails.address.street1}
                              placeholder={formatMessage({id: 'placeholder.street'})}
                              onChange={(e) => this.onAddressChange('street1', e.target.value)}
                              label={'address.street'} maxLength={50}
                              disabled={!canWrite}
                />
                <SAInputLabel value={bodyshopDetails && bodyshopDetails.address && bodyshopDetails.address.zipcode}
                              placeholder={formatMessage({id: 'placeholder.zipcode'})}
                              onChange={(e) => this.onAddressChange('zipcode', e.target.value)}
                              label={'address.zipcode'} maxLength={10}
                              disabled={!canWrite}
                />
                <SAInputLabel value={bodyshopDetails && bodyshopDetails.address && bodyshopDetails.address.city}
                              placeholder={formatMessage({id: 'placeholder.city'})}
                              onChange={(e) => this.onAddressChange('city', e.target.value)}
                              label={'address.city'} maxLength={30}
                              disabled={!canWrite}
                />
                <SAInputLabel value={bodyshopDetails && bodyshopDetails.address && bodyshopDetails.address.country}
                              placeholder={formatMessage({id: 'placeholder.country'})}
                              onChange={(e) => this.onAddressChange('country', e.target.value)}
                              label={'address.country'} maxLength={30}
                              disabled={!canWrite}
                />
              </div>
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id: 'section.bodyshop-contact.title'})}</h3>

                <SAInputLabel value={bodyshopDetails && bodyshopDetails.bodyshopPhone} maxLength={25}
                              placeholder={formatMessage({id: 'placeholder.phone'})}
                              onChange={(e) => this.onInputChange('bodyshopPhone', e.target.value)}
                              label={'section.bodyshop-contact.phone'}
                              disabled={!canWrite}
                />
                <SAInputLabel value={bodyshopDetails && bodyshopDetails.repairPhone} maxLength={25}
                              placeholder={formatMessage({id: 'placeholder.phone'})}
                              onChange={(e) => this.onInputChange('repairPhone', e.target.value)}
                              label={'section.bodyshop-contact.repair-phone'}
                              disabled={!canWrite}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id: 'section.generic-description.title'})}</h3>

                <Tabs type="card" defaultActiveKey="en">

                  {Constants.SUPPORTED_LANGUAGES.map(lg => {
                    return <TabPane tab={formatMessage({id: lg})} key={lg}>

                      <RichTextEditor defaultValue={genericDescription[lg]}
                                      onChange={(value) => {
                                        genericDescription[lg] = value;
                                        this.setState({genericDescription});
                                      }}/>
                    </TabPane>
                  })}
                </Tabs>
              </div>

            </div>

          </div>
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  dealerInfo: state.dealerInfo,
  loading: state.dealerInfo && state.dealerInfo.loading === true,
  error: (state.dealerInfo && state.dealerInfo.error && state.dealerInfo.error.content),
  configurationHints: (state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints) || []
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchDealerInfo: () => dispatch({type: 'FETCH.DEALER_INFO.REQUEST'}),
  dispatchSaveDealerInfo: (body) => dispatch({type: 'SAVE.DEALER_INFO.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(DealershipInformation), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
